import React from "react";
import { connect } from "react-redux";
import BackButton from "../widgets/BackButton";
import {
  getPatientWhatsAppMessagesList,
  loadMorePatientMessages,
  markAsReadWMessage,
  sendPatientWhatsappImage,
  sendPatientWhatsAppMessage,
} from "../../actions/patientWhMessagesActions";
import WhatsappImage from "../../assets/images/whatsapp-sender-icon.svg";
import IconAttachImg from "../../assets/images/attach-document.png";
import { getCompanyFormatFullDate } from "../../helpers/DateUtils";

function getMessageType(mimeType) {
  if (mimeType.startsWith("image/")) return "image";
  if (mimeType.startsWith("video/")) return "video";
  if (mimeType.startsWith("audio/")) return "audio";
  return "document";
}

@connect(({ patientWhMessages, whatsappChatting, clinicId }) => {
  return { patientWhMessages, whatsappChatting, clinicId };
})
export class WhatsAppChattingInterface extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
      selectedImage: null,
      selectedImagePreview: "",
      isLoadingMore: false,
    };
    this.chatContentRef = React.createRef();
    this.fileInputRef = React.createRef();
    this.isInitialLoad = true;
  }

  componentDidMount() {
    const { dispatch, location } = this.props;
    const patientKey = new URLSearchParams(location.search).get("pKey");
    dispatch(getPatientWhatsAppMessagesList({ patientKey, start: 0, limit: 20 }));

    this.pollingInterval = setInterval(() => {
      dispatch(getPatientWhatsAppMessagesList({ patientKey, start: 0, limit: 20 }));
    }, 60000);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.patientWhMessages.messages !== this.props.patientWhMessages.messages) {
      if (this.isInitialLoad) {
        this.isInitialLoad = false;
        this.scrollToBottom();
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.pollingInterval);
  }

  scrollToBottom = () => {
    const { dispatch } = this.props;
    if (this.chatContentRef.current) {
      this.chatContentRef.current.scrollTop = this.chatContentRef.current.scrollHeight;
      const patientKey = new URLSearchParams(this.props.location.search).get("pKey");
      dispatch(markAsReadWMessage({ patientKey }));
    }
  };

  handleScroll = () => {
    const container = this.chatContentRef.current;
    if (!container) return;

    if (container.scrollTop === 0 && !this.state.isLoadingMore) {
      const { messages, totalCount } = this.props.patientWhMessages;
      if (messages.length >= totalCount) return;

      const patientKey = new URLSearchParams(this.props.location.search).get("pKey");
      const prevScrollHeight = container.scrollHeight;

      this.setState({ isLoadingMore: true });

      this.props.dispatch(loadMorePatientMessages({ patientKey })).then(() => {
        this.setState({ isLoadingMore: false });
        requestAnimationFrame(() => {
          container.scrollTop = container.scrollHeight - prevScrollHeight;
        });
      });
    }
  };

  handleInputChange = (e) => {
    this.setState({ input: e.target.value });
  };

  handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    this.setState({
      selectedImage: file,
      selectedImagePreview: previewUrl,
    });
  };

  handleSubmitMessage = () => {
    const { input, selectedImage } = this.state;
    const patientKey = new URLSearchParams(this.props.location.search).get("pKey");

    if (!input.trim() && !selectedImage) return;

    if (selectedImage) {
      const formData = new FormData();
      formData.append("patientKey", patientKey);
      formData.append("photo", selectedImage);
      formData.append("caption", input || "");
      formData.append("messageType", getMessageType(selectedImage.type));

      this.props.dispatch(sendPatientWhatsappImage(formData)).then(() => {
        this.setState({ input: "", selectedImage: null, selectedImagePreview: "" });
        if (this.fileInputRef.current) this.fileInputRef.current.value = null;

        this.props.dispatch(getPatientWhatsAppMessagesList({ patientKey, start: 0, limit: 20 }));
      });
    } else {
      this.props.dispatch(sendPatientWhatsAppMessage({ patientKey, text: input })).then(() => {
        this.setState({ input: "" });
        this.props.dispatch(getPatientWhatsAppMessagesList({ patientKey, start: 0, limit: 20 }));
      });
    }
  };

  render() {
    const { patient } = this.props.whatsappChatting;
    const rawMessages = this.props.patientWhMessages.messages || [];
    const messages = [...rawMessages].reverse();

    return (
      <div style={{ width: "100%", position: "relative" }}>
        <div className="sidebar-header whatsapp-chatting-side-header">
          <div className="clearfix">
            <div className="col-sm-2 pl-1">
              <BackButton
                className="btn-sm pl-0"
                text="Back"
                onClick={this.props.hideWhatsAppChat}
              />
            </div>
            <div className="col-sm-8">
              <div className="whatsapp-note-title text-center">
                <p className="whatsapp-note-title-caption">Messages</p>
                <p className="whatsapp-note-title-chart">Chart#: {patient.chartNumber}</p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="whatsapp-chatting-content"
          ref={this.chatContentRef}
          onScroll={this.handleScroll}
        >
          {this.state.isLoadingMore && (
            <div style={{ textAlign: "center", padding: "8px 0" }}>
              <span>Loading...</span>
            </div>
          )}
          {messages.map((message, index) => {
            const sentMessage = message.status === "sent";
            return (
              <div key={message.id || index} className="whatsapp-chatting-message-wrapper">
                <div
                  className="whatsapp-chatting-message"
                  style={{ marginLeft: sentMessage ? "auto" : undefined }}
                >
                  <div
                    className="whatsapp-chatting-message-content"
                    style={{ backgroundColor: sentMessage ? "#cdd380" : "#dcdcd7" }}
                  >
                    {message?.imageUrl && (
                      <img
                        src={message?.imageUrl}
                        alt="Sent"
                        style={{ maxWidth: 200, borderRadius: 8 }}
                      />
                    )}
                    <p>{message.text}</p>
                  </div>
                  <p
                    className="whatsapp-chatting-message-date"
                    style={{ textAlign: sentMessage ? "right" : "left" }}
                  >
                    {getCompanyFormatFullDate(message.date)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {this.state.selectedImage && (
          <div style={{ position: "absolute", bottom: 60, left: 10 }}>
            {this.state.selectedImage.type.startsWith("image/") ? (
              <img
                src={this.state.selectedImagePreview}
                alt="Preview"
                style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 4 }}
              />
            ) : (
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 4,
                  background: "#e0e0e0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 10,
                  textAlign: "center",
                  padding: 4,
                  wordBreak: "break-all",
                }}
              >
                {this.state.selectedImage.name}
              </div>
            )}
            <button
              onClick={() => {
                this.setState({ selectedImage: null, selectedImagePreview: "" });
                if (this.fileInputRef && this.fileInputRef.current) {
                  this.fileInputRef.current.value = null;
                }
              }}
              style={{
                position: "absolute",
                top: -8,
                right: -8,
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: "red",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: 12,
                lineHeight: "20px",
                textAlign: "center",
              }}
            >
              ×
            </button>
          </div>
        )}

        <div
          style={{
            display: "flex",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "30px",
              position: "relative",
            }}
          >
            <input
              ref={this.fileInputRef}
              type="file"
              accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
              onChange={this.handleImageChange}
              style={{ opacity: 0, position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
            />
            <img src={IconAttachImg} width={20} height={20} alt="Attach icon" />
          </div>

          <div className="whatsapp-chatting-input-wrapper">
            <input
              type="text"
              value={this.state.input}
              onChange={this.handleInputChange}
              placeholder="Typing..."
              className="whatsapp-chatting-input"
            />
            <img
              onClick={this.handleSubmitMessage}
              className="whatsapp-chatting-sender-icon"
              src={WhatsappImage}
              alt="whatsapp sender"
            />
          </div>
        </div>
      </div>
    );
  }
}
